import { HorizontalBar, mixins } from 'vue-chartjs';
import chartMixin from './chartMixin';
export default {
  name: 'NiotaClassicChartsHorizontalBar',
  extends: HorizontalBar,
  mixins: [mixins.reactiveProp, chartMixin],
  props: {
    chartData: {
      type: Object,
      default: function () {
        return {};
      }
    },
    multiChartData: {
      type: Object,
      default: function () {
        return {};
      }
    },
    options: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  watch: {
    multiChartData: {
      handler: function () {
        this.updateBarChart();
      },
      deep: true
    },
    chartData: {
      handler: function () {
        this.updateBarChart();
      },
      deep: true
    }
  },
  mounted() {
    this.updateBarChart();
  },
  methods: {
    updateBarChart() {
      const mappedChartData = this.mapChartData();
      const chartOptions = this.chartOptions(this.options);
      this.renderChart({
        labels: mappedChartData.labels,
        datasets: mappedChartData.datasets
      }, chartOptions);
    },
    mapChartData() {
      if (this.multiChartData.individual) {
        return {
          datasets: this.multiChartData.individual.map((dataset, index) => {
            const color = this.multiChartData.common.color ? this.shadeColor(10 - index * 30, this.multiChartData.common.color || '#17bc00') : dataset.color;
            return {
              label: dataset.label,
              pointBackgroundColor: color,
              borderColor: color,
              backgroundColor: color || 'transparent',
              pointRadius: 1,
              borderWidth: 2,
              data: dataset.data
            };
          }),
          labels: this.multiChartData.common.labels
        };
      } else {
        const color = this.shadeColor(10, this.chartData.color || '#17bc00');
        return {
          labels: this.chartData.dataLabels,
          datasets: [{
            label: this.chartData.label,
            pointBackgroundColor: color,
            borderColor: color,
            backgroundColor: color || 'transparent',
            pointRadius: 1,
            borderWidth: 2,
            data: this.chartData.data
          }]
        };
      }
    }
  }
};